import { Editor } from '../Editor/Editor';
import { useState, useEffect, useRef } from 'react';
import { ButtonClose } from '@lk-gtcom/ecomlab-components';
import "./Comment.scss"

const parse = require('html-react-parser')

const Comment = ({
    name,
    email,
    commentValue = false,
    changeCommentValue,
    disabled,
    filesDataChange,
    setFilesDataChange,
    setFilesChange,
    isEdit,
    hideBtn,
    currentMessageAnswer,
    setCurrentMessageAnswer,
    setIsChanges = false,
    setSaveFile,
    fetchAddFiles,
    fetchGetFiles,
    comment_id,
    eventId,
    fetchDeleteFiles,
    saveFile,
    createFunc,
    message_id,
    isAuthor,
    messageData,
    fetchComments,
    plainTextOnly = false
}) => {

    const [comment, setComment] = useState(commentValue ? commentValue : '')
    const editorRef = useRef()

    const [filesData, setFilesData] = useState([])
    const [files, setFiles] = useState([])

    useEffect(() => {
        if (createFunc) {
            if (comment?.length > 0) {
                createFunc(comment)
                setComment('')
                editorRef?.current?.reset()
                setFiles([])
                setFilesData([])
                if (setSaveFile) setSaveFile([])
                setCurrentMessageAnswer(null)
            }
        } else {
            if ((comment?.length > 0) || (filesData?.length || filesDataChange?.length)) {
                if (commentValue) {
                    if (changeCommentValue) {
                        changeCommentValue(comment)
                    }
                    return
                }
                setCurrentMessageAnswer(null)
            }
        }

    }, [comment])

    return (
        <>
            {currentMessageAnswer && <div className='comment-answer'>
                <div className='comment-answer__header'>
                    <p className='comment-answer__author'>В ответ {currentMessageAnswer?.author?.name}</p>
                    <ButtonClose
                        onClick={(e) => setCurrentMessageAnswer(null)}
                        xs
                    />
                </div>
                <p className='comment-answer__text'>{currentMessageAnswer?.text ? parse(currentMessageAnswer?.text) : ''}</p>

            </div>}

            <div className={'comment'} >
                <div className='comment__content'>
                    <Editor
                        type={'comments'}
                        eventId={eventId}
                        fetchDeleteFiles={fetchDeleteFiles}
                        fetchGetFiles={fetchGetFiles}
                        comment_id={comment_id}
                        setSaveFile={setSaveFile}
                        fetchAddFiles={fetchAddFiles}
                        setIsChanges={setIsChanges}
                        hideEdit
                        hideBtn={hideBtn}
                        disabled={disabled}
                        comment
                        isEditComment={isEdit}
                        name={name}
                        bounds='.main-info'
                        title={null}
                        placeholder='Оставьте комментарий'
                        description={comment}
                        hideModules
                        saveOnBtn={!commentValue}
                        setDescription={setComment}
                        editValue={commentValue}
                        ref={editorRef}
                        filesdata={filesDataChange ? filesDataChange : filesData}
                        setFiles={setFilesDataChange ? setFilesDataChange : setFiles}
                        authorEmail={email}
                        setFilesData={setFilesChange ? setFilesDataChange : setFilesData}
                        setCurrentMessageAnswer={setCurrentMessageAnswer}
                        saveFile={saveFile}
                        message_id={message_id}
                        isAuthor={isAuthor}
                        messageData={messageData}
                        sendOnEnter={true}
                        fetchComments={fetchComments}
                        currentMessageAnswer={currentMessageAnswer}
                        plainTextOnly={plainTextOnly}
                    />
                </div>

            </div>
        </>
    )
}

export { Comment }